import React from 'react';
import { useNavigate } from 'react-router-dom';
import { soundManager } from '../utils/SoundManager';
import './BodyweightTrainers.css';

const BodyweightTrainers = () => {
    const navigate = useNavigate();

    // Bodyweight trainer options - based on your Android app structure
    const bodyweightTrainers = [
        {
            id: 'sarah-chen',
            name: 'Sarah Chen',
            specialization: 'Body Weight Training Specialist',
            image: '/assets/images/v22.jpg', // Based on your Android code
            route: '/trainer/sarah-chen',
            description: 'Former competitive gymnast specializing in progressive bodyweight mastery',
            experience: '8 years',
            specialty: 'Movement Patterns & Form',
            programs: 6
        },
        {
            id: 'marcus-steel',
            name: 'Marcus Steel',
            specialization: 'Functional Movement Expert',
            image: '/assets/images/v82.jpg',
            route: '/trainer/marcus-steel',
            description: 'Military fitness background with focus on functional strength',
            experience: '12 years',
            specialty: 'Functional Strength',
            programs: 6
        },
        {
            id: 'phoenix-wright',
            name: 'Phoenix Wright',
            specialization: 'Calisthenics Master',
            image: '/assets/images/v83.jpg',
            route: '/trainer/phoenix-wright',
            description: 'Street workout champion with advanced calisthenics expertise',
            experience: '10 years',
            specialty: 'Advanced Skills',
            programs: 6
        },
        {
            id: 'alex-steele',
            name: 'Alex Steele',
            specialization: 'Bodyweight Conditioning Coach',
            image: '/assets/images/v88.jpg',
            route: '/trainer/alex-steele',
            description: 'CrossFit athlete turned bodyweight conditioning specialist',
            experience: '9 years',
            specialty: 'Conditioning & Endurance',
            programs: 6
        },
        {
            id: 'jack-reynolds',
            name: 'Jack Reynolds',
            specialization: 'Progressive Overload Expert',
            image: '/assets/images/v75.jpg',
            route: '/trainer/jack-reynolds',
            description: 'Powerlifter who mastered bodyweight progressive overload techniques',
            experience: '11 years',
            specialty: 'Progressive Training',
            programs: 6
        },
        {
            id: 'mike-johnson',
            name: 'Mike Johnson',
            specialization: 'Beginner Development Coach',
            image: '/assets/images/v35.jpg',
            route: '/trainer/mike-johnson',
            description: 'Specializes in helping beginners build confidence and proper form',
            experience: '7 years',
            specialty: 'Beginner Programs',
            programs: 6
        }
    ];

    // Handle trainer selection
    const handleTrainerSelect = (trainer) => {
        console.log('Trainer selected:', trainer);

        // 🎵 PLAY TRAINER SELECTION SOUND
        soundManager.playSound('bodyweightSet2', 0.7);

        // Navigate to the specific trainer page
        navigate(trainer.route);
    };

    // Handle back to train categories
    const handleBackToCategories = () => {
        soundManager.playButtonSound();
        navigate('/train-categories');
    };

    return (
        <div className="bodyweight-trainers-container"> 
            <header className="bodyweight-trainers-header">
                <button
                    className="back-to-categories-button"
                    onClick={handleBackToCategories}
                >
                    ← Back to Categories
                </button>

                <div className="header-content">
                    <h1>Bodyweight Training Experts</h1>
                    <p>Choose your bodyweight training specialist</p>
                    <div className="category-stats">
                        <span className="stat-badge">6 Expert Trainers</span>
                        <span className="stat-badge">36 Total Programs</span>
                        <span className="stat-badge">4 Intensity Levels</span>
                    </div>
                </div>
            </header>

            <div className="trainers-grid">
                {bodyweightTrainers.map((trainer) => (
                    <div
                        key={trainer.id}
                        className="trainer-card"
                        onClick={() => handleTrainerSelect(trainer)}
                    >
                        <div className="trainer-image-section">
                            <div
                                className="trainer-image"
                                style={{
                                    backgroundImage: `url(${trainer.image})`,
                                    backgroundSize: 'cover',
                                    backgroundPosition: 'center'
                                }}
                            >
                                <div className="experience-badge">
                                    {trainer.experience}
                                </div>
                            </div>
                        </div>

                        <div className="trainer-info-section">
                            <h3 className="trainer-name">{trainer.name}</h3>
                            <h4 className="trainer-specialization">{trainer.specialization}</h4>
                            <p className="trainer-description">{trainer.description}</p>

                            <div className="trainer-details">
                                <div className="detail-item">
                                    <span className="detail-icon">🎯</span>
                                    <span className="detail-text">{trainer.specialty}</span>
                                </div>
                                <div className="detail-item">
                                    <span className="detail-icon">📋</span>
                                    <span className="detail-text">{trainer.programs} Programs</span>
                                </div>
                            </div>

                            <div className="trainer-action">
                                <button className="select-trainer-button">
                                    View Programs
                                </button>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            <footer className="bodyweight-trainers-footer">
                <div className="bodyweight-info">
                    <h3>💪 Bodyweight Training Benefits</h3>
                    <div className="benefits-grid">
                        <div className="benefit-item">
                            <span className="benefit-icon">🏠</span>
                            <div>
                                <strong>Train Anywhere</strong>
                                <p>No equipment needed - your body is your gym</p>
                            </div>
                        </div>
                        <div className="benefit-item">
                            <span className="benefit-icon">⚖️</span>
                            <div>
                                <strong>Functional Strength</strong>
                                <p>Build real-world strength and movement patterns</p>
                            </div>
                        </div>
                        <div className="benefit-item">
                            <span className="benefit-icon">📈</span>
                            <div>
                                <strong>Progressive Development</strong>
                                <p>Scale difficulty by adjusting leverage and reps</p>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        </div>
    );
};

export default BodyweightTrainers;